import { getFieldDefinition,readContentItems,deleteContentItems } from "../../../apis/httpHelper"
import baseField from "../BaseField"
import { ResponseCode } from "../../../common/constant"
import { checkEffectiveFilter, singleDataConvert } from "../../../common/commonHelper"
import { ElMessageBox, ElMessage } from 'element-plus'

export default {
    name:"LinkQueryField",
    mixins:[baseField],
    inject:["initState"],
    data:function(){
        return {
            total:0,
            
            loadingItems:false,
            isDisplayMode:true,
            gridDefinition:[],

            dialogVisible:false,
            requestTitle:"",
            requestOperation: "",
            requestContentType: "",
            requestContentItemId: "",
            requestFlowNodeId: "",
            requestNodeIds: [],
            requestPassingParameter: [],

            isDisplayFlowInfo:false,

            currentpage: 1,
            pagesize: 20,
            isHiddenPage: true,

            displayType: 0,
            importState: false,
            importPassingParameter:[],

            selectItemIds: [],

            exportItem:{
                contentType:"",
                sort:[],
                filter:{},
                orginaldataFilter:{},
                excelExportState:false,
                exportFields:[],
            },

            filterItems:{},

            superImport:false,
            superImportWorkflows:[],
            deleteName: "移除",
            newName: "添加",
            excelName: "Excel导入",
            batchDeleteName: "批量删除",
            editName: "编辑",

            showMode:false
        }
    },

    computed:{
        range:function(){
            return { "skip":(this.currentpage - 1) * this.pagesize, "take":this.pagesize  }
        },
        subformCreate:function(){
            return this.formDefinition[this.name].SubformCreate;
        },
        subformDelete:function(){
            return this.formDefinition[this.name].SubformDelete;
        },

        computedInitState:function(){
            return this.initState;
        }
    },

    watch:{
        range:{
            handler(newValue, oldValue) {
                if(!(newValue.skip == oldValue.skip && newValue.take == oldValue.take)){
                    this.getAllRow();
                }
            },
            deep: true
        },

        computedInitState:function(newValue, oldValue){
            this.loadContentItems()
        }
    },

    created: function () {
        this.data[this.name] = { total: 0, data: [] };

        this.requestContentType = this.selfSetting.ContentType;
        this.exportItem.contentType = this.selfSetting.ContentType;
        this.createAble = this.formDefinition[this.name].SubformCreate;
        this.superImport = this.selfSetting.SuperImport;
        this.superImportWorkflows = this.selfSetting.SuperImportWorkflows;
        this.showMode = this.selfSetting.ShowMode;
        
        this.isDisplayFlowInfo = this.selfSetting.IsDisplayFlowInfo;
        this.displayType = this.selfSetting.hasOwnProperty("DisplayType") ? this.selfSetting.DisplayType : 0;
        if (this.selfSetting.hasOwnProperty("ButtonSetting")) {
            this.newName = this.selfSetting.ButtonSetting.NewName;
            this.editName = this.selfSetting.ButtonSetting.EditName;
            this.deleteName = this.selfSetting.ButtonSetting.DeleteName;
            this.batchDeleteName = this.selfSetting.ButtonSetting.BatchDeleteName;
            this.excelName = this.selfSetting.ButtonSetting.ExcelName;
        }

        getFieldDefinition(this.selfSetting.ContentType,this.selfSetting.DisplayFields)
            .then(x=>{
                let result = new Array();
                this.selfSetting.DisplayFields.forEach(y=>{
                    result.push(x.Result.find(item => item.Name == y));
                })
                this.gridDefinition = result.filter(x=> x != null || x != undefined);

                this.exportItem.exportFields = result.filter(x=> x != null || x != undefined).map(x=>{
                    return {
                        DisplayName: x.Settings.ContentPartFieldSettings.DisplayName,
                        Name: x.Name,
                        Type: x.FieldDefinition.Name
                    }
                });

                let self = this;
                if(this.showMode){
                    let queryFunc = new Function("Context", "Content", this.selfSetting.FilterSettingString || "return null");
                    
                    let filterSettingRely = this.selfSetting.FilterSettingRely || [];

                    if(filterSettingRely.length > 0){
                        filterSettingRely.forEach(x => {
                            this.$watch("data." + x, function (newVal, oldVal) {
                                let context = this.buildFormContext();
                                let filter = queryFunc(context, context.Content);
                                self.getData(filter);
                            },{
                                deep:true
                            })
                        })
                    }
                    let context = this.buildFormContext();
                    let filter = queryFunc(context, context.Content);
                    self.getData(filter);
                }
                else{
                    let FilterParameters = this.selfSetting.FilterParameters || [];
                    let relys = FilterParameters.map(x=> x.OriginalKey);
                    relys.forEach(x => {
                        this.$watch("data." + x, function (newVal, oldVal) {
                            self.getData();
                        })
                    })
                    this.getData();
                }
            });
    },

    methods:{
        createdModeFilter:function(){
            if(this.selfSetting.ShowMode){
                let context = this.buildFormContext();
                let queryFunc = new Function("Context", "Content", this.selfSetting.FilterSettingString || "return null");
                let filter = queryFunc(context, context.Content);
                return filter;
            }
            else{
                let FilterParameters = this.selfSetting.FilterParameters || [];
                let filters = new Array();
                FilterParameters.forEach(x => {
                    if (this.data[x.OriginalKey] == null || this.data[x.OriginalKey] == undefined) {
                        
                    }
                    else{
                        filters.push({
                            "field": x.TargetKey,
                            "operator": "eq",
                            "value": this.data[x.OriginalKey]
                        });
                    }
                });
                let queryFilter = undefined;
                if(filters.length != 0){
                    queryFilter = {
                        "logic": "And",
                        "filters": filters
                    }
                }
                return queryFilter;
            }
        },

        loadContentItems:function(){
            if(this.showMode){
                let queryFunc = new Function("Context", "Content", this.selfSetting.FilterSettingString || "return null");
                let context = this.buildFormContext();
                let filter = queryFunc(context, context.Content);
                this.getData(filter);
            }
            else{
                this.getData();
            }
        },

        getData:function(filter){
            if(this.showMode){
                this.getAllRowByQuery(filter)
            }
            else{
                this.getAllRow();
            }
        },

        getAllRowByQuery:function(filter){
            this.loadingItems = true;
            this.$nextTick(x=>{
                readContentItems(this.requestContentType,this.selfSetting.DisplayFields,this.range.skip, this.range.take, undefined, filter, true)
                    .then(x=> {
                        let result = x.Result;
                        this.data[this.name] = this.dataPreHandler(result);
                        this.loadingItems = false;
                    });
                });
        },

        getAllRow:function(){
            this.loadingItems = true;
            this.$nextTick(x=>{
                let queryFilter = this.createdModeFilter();
                if(checkEffectiveFilter(queryFilter)){
                    readContentItems(this.requestContentType,this.selfSetting.DisplayFields,this.range.skip, this.range.take, undefined, queryFilter, true)
                    .then(x=> {
                        let result = x.Result;
                        this.data[this.name] = this.dataPreHandler(result);
                        this.loadingItems = false;
                    });
                }
                else{
                    this.loadingItems = false;
                }
            })
        },

        dataPreHandler:function(response){
            response.data.forEach(dataItem =>{
                this.gridDefinition.forEach(field=>{ 
                    dataItem[field.Name] =  singleDataConvert(dataItem[field.Name], field.FieldDefinition.Name);
                });
            })
            return response;
        },

        newItem:function(){
            this.requestOperation = "Create";
            this.requestPassingParameter = (this.selfSetting.PassingParameters || []).map(x => {
                return {
                    "Name": x.TargetKey,
                    "Value": this.data[x.OriginalKey]
                };
            });
            this.dialogVisible = true;
        },

        formSubmit:function(operator, code){
            if(code == ResponseCode.Success || code == ResponseCode.SuccessAndWarn){
                this.dialogVisible = false;
                this.getAllRow();
            }
        },

        initForm: function (code, formBuilder) {
            if (code === ResponseCode.Success) {
                this.requestTitle = formBuilder.CurrentDisplayName;
            }
            else {
                this.dialogVisible = false;
            }
        },

        editRow:function(contentItemId){
            this.requestOperation = "Edit";
            let NodeAssociations = this.selfSetting.NodeAssociation || [];
            let buildForm = this.buildFormContext();
            let currentNode = buildForm.Properties.CurrentNodeId;
            let Nodes = new Array();

            NodeAssociations.forEach(x => {
                if (x.OriginalKey === currentNode) {
                    Nodes.push(x.TargetKey);
                }
            });

            this.requestNodeIds = Nodes;
            this.requestContentItemId = contentItemId;
            this.requestPassingParameter = new Array();
            this.dialogVisible = true;
        },

        handleSelectionChange:function(selects){
            this.selectItemIds = selects.map(x=>x.ContentItemId);
        },

        allDelete:function(){
            ElMessageBox.confirm(
                '将对 ' + this.selectItemIds.length + ' 条数据执行 删除 操作, 是否继续?' ,
                '提示',
                {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
            .then(() => deleteContentItems(this.selectItemIds))
            .then(x=>{
                ElMessage.success('删除成功');
                this.getAllRow();
            }).catch(x=>{
                console.log(this.displayName + "-" +this.name + "删除异常");
                console.log(x);
            })
            .catch(x => {
                console.log(x);
            })
        },

        deleteRow:function(item){
            deleteContentItems(new Array(item.ContentItemId))
            .then(x=>{
                ElMessage.success('删除成功');
                this.getAllRow();
            }).catch(x=>{
                console.log(this.displayName + "-" +this.name + "删除异常");
                console.log(x);
            })
        },

        importByExcel:function(){
            this.importPassingParameter = (this.selfSetting.PassingParameters || []).map(x => {
                return {
                    "FieldName": x.TargetKey,
                    "UpdateMode": 0,
                    "Value": this.data[x.OriginalKey]
                };
            });
            this.importState = true;
        },

        exportByExcel:function(){
            if(this.showMode){
                let queryFunc = new Function("Context", "Content", this.selfSetting.FilterSettingString || "return null");
                let context = this.buildFormContext();
                let filter = queryFunc(context, context.Content);
                this.exportItem.filter = filter;
            }
            else{
                this.exportItem.filter = this.createdModeFilter();
            }
            this.exportItem.excelExportState = true;
        },

        initImport:function(code){
            if(!code){
                ElMessage.error("系统异常，稍等一会再试");
                this.importState = false;
            }
        },

        finishImport:function(){
            this.importState = false;
            this.getAllRow();
        },
    }
}